module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": _vm.svgSize,
      "height": _vm.svgSize
    }
  }, [_c('defs', [_c('clipPath', {
    attrs: {
      "id": "clipPath"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0",
      "y": "0",
      "width": _vm.basesize,
      "height": _vm.basesize
    }
  })])]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": _vm.transform
    }
  }, [_c('rect', {
    attrs: {
      "x": "0",
      "y": "0",
      "width": _vm.basesize,
      "height": _vm.basesize,
      "fill": "white",
      "stroke": "white",
      "stroke-width": "1px"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-red clippath-url",
    attrs: {
      "d": _vm.redPath,
      "stroke-width": "1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-orange clippath-url",
    attrs: {
      "d": _vm.orangePath,
      "stroke-width": "1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-green clippath-url",
    attrs: {
      "d": _vm.greenPath,
      "stroke-width": "1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-white clippath-url",
    attrs: {
      "d": _vm.whitePath,
      "stroke": "white",
      "stroke-width": "4px"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-gray clippath-url",
    attrs: {
      "d": _vm.grayPath,
      "stroke": "gray",
      "stroke-width": "1px"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-black clippath-url",
    attrs: {
      "d": _vm.blackPath,
      "stroke": "black",
      "stroke-width": "6px"
    }
  }), _vm._v(" "), _c('rect', {
    style: (_vm.style),
    attrs: {
      "x": "0",
      "y": _vm.basesize * 0.75,
      "width": _vm.basesize,
      "height": _vm.basesize * 0.25,
      "stroke": "none",
      "stroke-width": "1"
    }
  }), _vm._v(" "), _c('text', {
    staticClass: "text-anchor-middle",
    attrs: {
      "x": _vm.basesize * 0.5,
      "y": _vm.basesize * 0.93,
      "font-family": "Verdana",
      "font-size": "46",
      "fill": "black"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.name) + "\n      ")]), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "0",
      "width": _vm.basesize,
      "height": _vm.basesize,
      "fill": "none",
      "stroke": "gray",
      "stroke-width": "1px"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48a25212","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nutrieduc/Galva.vue
// module id = 1187
// module chunks = 1